import { getAPIBaseURL } from './helpers'
import { getData, postData } from './request'

const base = () => `${getAPIBaseURL()}/v1`

const getAuthHeaders = () => {
  const token = localStorage.getItem('token')
  return token ? { 'token': token } : {}
}

export const listTickets = async () => {
  const url = `${base()}/tickets`
  const headers = getAuthHeaders()
  const res = await getData(url, headers, {})
  if (res.error === '') {
    return { status: res.result.status, data: res.result.data.data || res.result.data }
  }
  return { status: res.result?.status || 500, error: res.result?.data }
}

export const listAttendeeTickets = async (filters = {}) => {
  const url = `${base()}/attendee/tickets`
  const headers = getAuthHeaders()
  const queryParams = new URLSearchParams()
  if (filters.eventId) queryParams.append('eventId', filters.eventId)
  if (filters.offerId) queryParams.append('offerId', filters.offerId)
  if (filters.status) queryParams.append('status', filters.status)
  const queryString = queryParams.toString()
  const fullUrl = queryString ? `${url}?${queryString}` : url
  const res = await getData(fullUrl, headers, {})
  if (res.error === '') {
    return { status: res.result.status, data: res.result.data.data || res.result.data }
  }
  return { status: res.result?.status || 500, error: res.result?.data?.data || res.result?.data?.message }
}

export const listCenterTickets = async (filters = {}) => {
  const url = `${base()}/center/tickets`
  const headers = getAuthHeaders()
  const queryParams = new URLSearchParams()
  if (filters.eventId) queryParams.append('eventId', filters.eventId)
  if (filters.status) queryParams.append('status', filters.status)
  const queryString = queryParams.toString()
  const fullUrl = queryString ? `${url}?${queryString}` : url
  const res = await getData(fullUrl, headers, {})
  if (res.error === '') {
    return { status: res.result.status, data: res.result.data.data || res.result.data }
  }
  return { status: res.result?.status || 500, error: res.result?.data?.data || res.result?.data?.message }
}

export const validateTicket = async (payload) => {
  const url = `${base()}/tickets/validate`
  const headers = {
    'Content-Type': 'application/x-www-form-urlencoded',
    ...getAuthHeaders()
  }
  const params = new URLSearchParams()
  Object.keys(payload).forEach(key => {
    if (payload[key] !== undefined && payload[key] !== null) {
      params.append(key, payload[key])
    }
  })
  const res = await postData(url, headers, params.toString())
  if (res.error === '') {
    return { status: res.result.status, data: res.result.data.data || res.result.data }
  }
  return { status: res.result?.status || 500, error: res.result?.data?.data || res.result?.data?.message }
}

export const revokeTicket = async (ticketId) => {
  const url = `${base()}/tickets/${ticketId}/revoke`
  const headers = getAuthHeaders()
  const res = await postData(url, headers, {})
  if (res.error === '') {
    return { status: res.result.status, data: res.result.data.data || res.result.data }
  }
  return { status: res.result?.status || 500, error: res.result?.data?.data || res.result?.data?.message }
}

export const listAdminTickets = async (params = {}) => {
  const url = `${base()}/admin/tickets`
  const headers = getAuthHeaders()
  const res = await getData(url, headers, params)
  if (res.error === '') {
    return { status: res.result.status, data: res.result.data.data || res.result.data }
  }
  return { status: res.result?.status || 500, error: res.result?.data?.data || res.result?.data?.message }
}

export const getAdminTicketById = async (ticketId) => {
  const url = `${base()}/admin/tickets/${ticketId}`
  const headers = getAuthHeaders()
  const res = await getData(url, headers, {})
  if (res.error === '') {
    return { status: res.result.status, data: res.result.data.data || res.result.data }
  }
  return { status: res.result?.status || 500, error: res.result?.data?.data || res.result?.data?.message }
}

